/**
 * Shared MoR publishable keys and helpers for the CRM app.
 *
 * This file mirrors the constants from `src/lib/payment/constants.ts` in the
 * main app but only includes the client-safe exports (no process.env references).
 *
 * Keeping a single canonical copy is impractical today because the CRM app is
 * a standalone Vite app whose `@/` alias points to its own `src/`.
 *
 * If you update keys here, update `src/lib/payment/constants.ts` too.
 */

export const MOR_PUBLISHABLE_KEYS: Record<string, { test: string; live: string }> = {
  tagadapay: {
    test: 'pk_test_51RPMKqRs4bPAxQTjrCJuWN7pP1x2OC1OqrnJvtX7XPlLRcsITKBjjwrPqG1fQ4nzTOOerGwQJIruBrMAeYsk1idZ00BsLXAU9Y',
    live: 'pk_live_51RPMKqRs4bPAxQTjDmeMp5VCkPEhNeR3QjbneG0KqETfXYPg9PkwQWOoZL1FPcLL2hYcZSCtRN4KrGNmcONz8Z1J00j6A4mYuC',
  },
  efipayments: {
    test: '',
    live: 'pk_live_51SuVHeK1Z4XBUiZSB5dmeREwYAZfHTzJBHw4FCxxhrHILQ0IMMLLs4tFqLmBd6pA7u95Mdg4PJRKte5i20XeIddI001NQ4moSw',
  },
  bakolapay: {
    test: '',
    live: 'pk_live_51SnKdWDCrKqi4iY7M0ytB78gpmWICmG2HAsjZ32vbPBVvtEZJ5SJcX9l5kQQw3vhv7biDJLPhOg72xHkMv4Zr3r200GOVT9GbG',
  },
  merchantscale: {
    test: 'pk_test_51SuXhd1nBR4f1QR61viXSKMY7J3PRJoU851iBk4nhzzXkznKusByIWB40BvOGpMh8mSZCEFp9W5fy0FqW6PKhzTe00xfiLUnca',
    live: 'pk_live_51SlGz81CHzKD4hVFb0mvvKNiNY6rcCUmQHcXxYKMoj29Ik3R6fvKjjbxpkfvhdtdmSDoS1fkJQMwlhMLMR2b2KW600XX65mNPN',
  },
};

export const MOR_PROCESSOR_TYPES = Object.keys(MOR_PUBLISHABLE_KEYS);

export function isMorProcessor(processorType: string): boolean {
  return processorType in MOR_PUBLISHABLE_KEYS;
}

export function isTestEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h.includes('localhost') || h.includes('.dev') || h.includes('test');
}

export function getMorPublishableKey(processorType: string, isTest: boolean): string {
  const keys = MOR_PUBLISHABLE_KEYS[processorType];
  if (!keys) return '';
  return isTest ? keys.test : keys.live;
}

export function getMorPublishableKeyForEnv(processorType: string): string {
  return getMorPublishableKey(processorType, isTestEnvironment());
}
